export const MY_TOOLS_DROPDOWN = [
  {
    name: ' Income Tax Calculator',
    href: '/paytax/TaxCalculator',
  },
  {
    name: 'Refund status checker',
    href: '/s/income-tax-refund',
  },
  {
    name: 'HRA calculator',
    href: '/paytax/TaxCalculator',
  },
  {
    name: 'Rent receipt Generator',
    href: '/save/rent',
  },
];
